<template>
    <div>
        <b-row>
            <b-col cols="12">
            <div class="container-fluid">
            <div>
               <b-card border-variant="secondary" header-text-variant="black">
                   <div slot="header"  v-b-toggle.accordion-1 style="cursor:pointer">
                       <h3 align="center">Subir Archivos Excel de acuerdo a los ejemplos</h3>                       
                   </div>
                   <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                   <div>
                       <b-row>
                           <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                               <div align="center">
                                   <b>Boletas Encabezados</b> || <b-link href="http://telemovildata.com/producto/Ejemp-Encabezado-Boletas.xlsx" variant="primary">Ejemplo</b-link>
                               </div>   
                               <div class="wrapper">  
                                   <div class="file-upload">
                                        <!-- <i class="fa fa-arrow-up"></i> -->
                                        <i class="fas fa-file-upload"></i>
                                        <b-form-file v-model="file" class="mt-3" plain></b-form-file>
                                   </div>                                  
                               </div>
                           </b-col> 
                           <b-col cols="12" sm="12" md="12" lg="12" xl=3>
                               <div align="center">
                                   <b>Boletas Items</b> || <b-link href="http://telemovildata.com/producto/Ejemp-Detalle-Boletas-Items.xlsx">Ejemplo</b-link>
                               </div>
                            <div class="wrapper">  
                                   <div class="file-upload">
                                        <!-- <i class="fa fa-arrow-up"></i> -->
                                        <i class="fas fa-box-open"></i>
                                        <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                                   </div>                                  
                               </div>
                           </b-col>
                           <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                               <div align="center">
                                   <b>Adicionales</b> || <b-link style="color:red" href="http://telemovildata.com/producto/ejemp-plantilla-adicionales.xlsx">Ejemplo (Opcional)</b-link> Agregar Serie|| Enviando en <b>{{ dismissCountDown }}</b>
                                   <div style="display:none">                                
                                        <b-alert
                                        :show="dismissCountDown"                          
                                        @dismissed="dismissCountDown=0"
                                        @dismiss-count-down="countDownChanged"
                                        >
                                        <!-- Enviando en {{ dismissCountDown }}   -->
                                        </b-alert>
                                    </div>
                               </div>                 
                               <div class="wrapper">  
                                   <div class="file-upload">
                                        <i class="fas fa-file-upload"></i>
                                        <b-form-file v-model="adicionales" class="mt-3" plain></b-form-file>
                                   </div>                                  
                               </div>
                            </b-col>  
                            <b-col cols="12" sm="12" md="12" lg="12" xl="2">
                                 <b-button-group class="mt-5">
                                <template v-if="file == null || file2 == null">
                                   <div align="">
                                   <b-button variant="primary" disabled>
                                        <i class="fas fa-upload"></i> 
                                        Importar
                                    </b-button>
                                    </div>
                               </template>
                               <template v-else>
                                <div align="center">
                                <b-button              
                                variant="primary" 
                                title="Guardar Archivo" 
                                @click="subirEncabezado()">
                                <i class="fas fa-upload"></i> 
                                Importar
                                </b-button> 
                                </div>
                                </template>
                                <b-button class="ml-4" variant="success" title="Emitir todos los Documentos" :disabled="masivaboton" @click="masivaBoletas()"><i class="fas fa-play"></i></b-button>
                                <b-button class="ml-4" title="Borrar total Documentos" variant="danger" :disabled="listaDocumentos.length == 0" @click="borrarDocumentosBol"><i class="fas fa-trash-alt"></i></b-button>
                                 </b-button-group>
                            </b-col>                     
                       </b-row>
                       <b-row>
                           <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                               <!-- <div style="float: left;" class="mt-2 pl-2"><b>Boletas Encabezados:</b></div> -->
                               <div align="center">
                                   <h5><b-badge variant="warning"> {{ file ? file.name : '' }}</b-badge></h5>
                               </div>  
                           </b-col>
                           <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                               <!-- <div style="float: left;" class="mt-2 pl-2"><b>Boletas Items:</b></div> -->
                               <div align="center">
                                    <h5><b-badge variant="warning"> {{ file2 ? file2.name : '' }}</b-badge></h5>   
                               </div> 
                           </b-col>
                           <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                               <div align="center">
                                    <h5><b-badge variant="warning"> {{ adicionales ? adicionales.name : '' }}</b-badge></h5>   
                               </div> 
                            </b-col>
                       </b-row>                      
                   </div>
                   </b-collapse>
               </b-card>
            </div>
            </div>
            </b-col>
            <vue-snotify></vue-snotify>
        </b-row>
        <!--listado de documentos-->
        <div class="container-fluid">
            <div>
            <b-card border-variant="secondary" header-text-variant="black">
                <div slot="header">
                    <h3 align="center">Lista de Documentos</h3>
                </div>
                <div class="">
                    <template v-if="!cargandomasiva">
                        <div align="center">
                             <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                        <b-row>
                        <b-col cols="9">
                            <b-button variant="primary" title="actualizar" @click="listamasiva()">Actualizar <i class="fas fa-redo-alt"></i></b-button>
                        </b-col>
                        <b-col cols="3">
                        <b-form-group horizontal label="Mostrar">
                        <b-input-group>
                            <b-form-select v-model="limit" slot="append" @input="listamasiva">
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                            </b-form-select>
                        </b-input-group>
                        </b-form-group>
                        </b-col>
                        </b-row>             
                <b-table
                    responsive 
                    :items="listaDocumentos"
                    :fields="fields_documentos"
                    striped
                    :outlined="outlined">
                <template slot="documento" slot-scope="row">
                    {{row.item.serie}}-{{row.item.numero}}
                </template>
                <template slot="receiver" slot-scope="row">
                    <template v-if="row.item.receiver.tipo != '0'">
                        {{row.item.receiver.idReceptor}} - {{row.item.receiver.razonSocial}}
                    </template>    
                    <template v-else-if="row.item.receptor && row.item.receptor.nro">
                        {{row.item.receptor.nro}} - {{row.item.receptor.razonSocial}}
                    </template>
                </template>
                <template slot="importeTotal" slot-scope="row">
                    <template v-if="row.item.tipoMoneda=='PEN'">S/</template> 
                    <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
                    <template v-else-if="row.item.tipoMoneda=='EUR'">€</template>
                    {{row.item.importeTotal}}
                </template>
                <template slot="estado" slot-scope="row">
                <div>
                    <template v-if="row.item.emitido==1 && row.item.baja==1">
                        <div>
                            <span class="badge badge-dark">Baja<i class="fa fa-ban"></i></span>
                        </div>
                    </template>
                    <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                        <div>
                            <span class="badge badge-info">Baja pendiente<i class="fa fa-ban"></i></span>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="row.item.emitido==1">
                            <span class="badge badge-success">Emitido<i class="fa fa-check"></i></span>
                        </div>
                        <div v-else-if="row.item.emitido==0">
                            <span class="badge badge-warning">Procesando<i class="fa fa-spin fa-spinner"></i></span>
                        </div>
                        <div v-else-if="row.item.emitido==2">
                            <span class="badge badge-danger">Rechazado<i class="fa fa-times"></i></span>
                        </div>
                        <div v-else-if="row.item.emitido==6">
                            <span class="badge badge-info">Procesando OSE<i class="fa fa-times"></i></span>
                        </div>
                    </template>
                </div>
                </template>
                <template slot="acciones" slot-scope="row">
                    <b-button-group>
                    <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                        <template v-if="!row.detailsShowing">
                            <i class="fa fa-plus"></i>                                
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button variant="success" size="sm"  title="Emitir Documento" @click="emitirdoc(row.item)">
                        <i class="fas fa-play"></i>
                    </b-button>
                    <b-button variant="dark" size="sm" title="Borrar" @click="eliminardoc(row.item)">
                        <i class="fas fa-trash-alt"></i>             
                    </b-button>
                    <template v-if="row.item.adicional && row.item.adicional.obs !=''">
                        <b-button variant="warning"
                        @click="abrirModal(row.item)">
                        <i class="fas fa-exclamation-circle"></i>
                        </b-button>
                    </template>
                    </b-button-group>
                </template>
                <template  v-slot:row-details="row">
                    <b-card>
                        <b-table
                        head-variant="light"
                        responsive
                        small
                        :items="row.item.items"
                        :fields="listaitems_fields">
                        <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                        <template slot="cantidad" slot-scope="row">
                            {{ Number.parseFloat(row.item.cantidad).toFixed(2)}}
                        </template>
                        <template slot="precioVentaUnitario" slot-scope="row">
                            {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2)}} 
                        </template>
                        <template slot="valorUnitario" slot-scope="row">
                            {{ Number.parseFloat(row.item.valorUnitario).toFixed(2)}}
                        </template>
                        </b-table>
                    </b-card>
                </template>
                </b-table>
                        </div>
                        <!-- boleta no fue emitida -->
                <b-modal id="modal-visualizar" title="Motivo" v-model="mostrarModal">
                    <div v-if="dataSeleccionada">
                        <p><strong>Boleta {{dataSeleccionada.serie}} - {{ dataSeleccionada.numero }} </strong> {{ dataSeleccionada.adicional.obs }}</p>
                    </div>
                    <div v-else>
                        <p>No hay datos para mostrar.</p>
                    </div>
                </b-modal>
                <b-row>
                    <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </b-col>
                    <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                        <b-pagination
                            size="sm"
                            v-model.number="pactual"
                            :total-rows="total"
                            :per-page="limit"
                            @input="listamasiva"
                            aria-controls="my-table"
                        ></b-pagination>
                    </b-col>
                </b-row>
                    </template>
                <documentomasivos :item="separarArray" :action="action" @totalitems="totalitems"></documentomasivos>
            <b-modal v-model="modalmasivaboleta" centered size="lg">
            <div>       
                <b-row no-gutters>
                <b-col md="5" class="ml-4">
                    <b-img src="images/error3.png"  height="260%" style="width:90%" ></b-img>
                </b-col>
                <b-col md="6">
                    <b-card-body title="Ups! error">
                        <b-card-text>
                            {{error1}} <br>
                            <hr>
                            {{error2}} <br>
                            <hr>
                            {{error3}}
                        </b-card-text>
                    </b-card-body>
                </b-col>
                </b-row>
            </div>
            <template slot="modal-footer">
                <b-button variant="danger" @click="cerrarmodal()" >Cerrar</b-button>
            </template>
             </b-modal>
                   </div>
                </b-card>
            </div>
             <vue-snotify></vue-snotify>
        </div> 
    </div>
</template>
<script>
import axios from 'axios'
import Documentomasivos from "@/components/comunes/documentomasivos"
export default {
    name:'SubirDocumentos',
    components:{
        Documentomasivos,
    },
    data:() =>{
        return {
            file: null,
            file2: null,
            adicionales:null,
            listaDocumentos:[],
            fields_documentos:[
                { key: "documento", label:"Documento", sorteable: true},
                { key: "fechaEmision", label:"Fecha Emisón", sorteable: true},
                { key: "receiver", label:"Receptor", sorteable: true},
                { key: "importeTotal", label:"Total", sorteable:true},
                { key: "estado", label:"Estado", sorteable:true},
                { key: "acciones", label:"Acciones", sorteable:true},
                ],
            limit:15,
            order:'desc',
            outlined: true,
            cargandomasiva: false,
            pactual:1,
            total: 0.0, 
            desde: 0.0,
            hasta: 0.0,
            total: 0.0,  
            senddoc:{
                receptor:{
                    tipo:'',
                    nro:'',
                    razonSocial:'',
                    direccion:''
                },
                receiver:{
                    idReceptor:'',
                    tipo:'',
                    razonSocial:'',
                    direccionReferencia:''
                },
            },
            fechaprueba:"2020-12-28",
            listaitems_fields: [
                { key: "index" },
                { key: "codigoProducto", label: "Codigo", sorteable: true },
                { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                { key: "descripcion", label: "Descripción", sorteable: true },
                { key: "cantidad", label: "Cantidad", sorteable: true },
                { key: "precioVentaUnitario", label: "P. Unitario", sorteable: true },
                { key: "montoAfectacionIgv", label: "Igv", sorteable: true },
                { key: "valorVenta", label: "Valor Total", sorteable: true }
            ],
            action: {
                i: false,
                reset: false
            },
            itemsCargados:[],
            separarArray:[],
            contingencia:false,
            modalmasivaboleta:false,
            error1:'',
            error2:'',
            error3:'',
            masivaboton:true,
            dismissSecs: 10,
            dismissCountDown: 0,
            mostrarModal: false,
            dataSeleccionada: null
        }
    },
    mounted() {
        this.listamasiva();
    },
    computed:{
    },
    watch:{
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        totalitems(value){
            this.itemsCargados = value
            this.action.i = false;
        },
        subirEncabezado(){
            let formData = new FormData();
            formData.append("token",this.$store.getters.userToken);
            formData.append("encabezado",this.file);
            formData.append("detalles",this.file2);
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/boletas/encabezados", 
                formData,
                {
                    responseType: "blob",
                    headers: {
                    "Content-Type": "multipart/form-data"
                    }
                }
            )
            .then(response=>(
                 this.$snotify.success("Documento importado exitosamente!", "Exito"),
                 this.file = null,
                 this.file2 = null
                //this.changeTab(1)
            ))
            .catch(error=>(               
                this.$swal({
                    title: 'Error al cargar documento',
                    text: 'Revisar que el documento de Excel este rellenado correctamente',
                    icon: 'error',
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                    this.file = null
                    }
                }) 
            ))
            this.showAlert()
            setTimeout(()=> this.subirAdicionales(),10000);
        },
        subirItems(){
            let dataItems = new FormData();
            dataItems.append("token",this.$store.getters.userToken);
            dataItems.append("detalles",this.file2);
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/boletas/detalle", 
                dataItems,
                {
                    responseType: "blob",
                    headers: {
                    "Content-Type": "multipart/form-data"
                    }
                }
            )
            .then(response=>(
                this.$snotify.success("Items importados exitosamente!", "Exito"),
                this.file2 = null
                //this.changeTab(1)
            ))
            .catch(error=>(
                this.$swal({
                    title: 'Error al cargar documento',
                    text: 'Revisar que el documento de Excel este rellenado correctamente',
                    icon: 'error',
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                    this.file2 = null
                    }
                })    
            ))  
        },
        changeTab(value){
            this.$emit("tabIndex", value);   
        },
        listamasiva(){
            this.cargandomasiva = false
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/boletas/listar",{
                token: this.$store.getters.userToken,
                page: this.pactual,
                limit: this.limit,
                order: this.order
            })
            .then(response=>(
                this.listaDocumentos = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargandomasiva = true,
                this.listaDocumentos.length > 0 ? this.masivaboton = false : this.masivaboton = true
            ))
            .catch(error=>(
                 this.$snotify.error(error.response.data.msg, "Error")
            ))
        },
        eliminardoc(value){
            this.$swal({
                title: 'Eliminar ',
                text: '¿Está seguro de eliminar el documento' + ' ' + value.serie + '-' + value.numero + '?',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    axios.
                    post(process.env.VUE_APP_API_URL + "facturacionmasiva/boletas/eliminar",{
                        token: this.$store.getters.userToken,
                        identificador: value.identificador
                    })
                    .then(response=>(
                        this.$snotify.success(response.data.msg),
                        this.listamasiva()
                    ))
                    .catch(error=>(
                        this.$snotify.error(error.response.data.msg, "Error")
                    ))
                }
            })  
        },
        emitirdoc(value){
        this.action.i = true  
        this.separarArray = value.items
        this.action.reset = false
        if(value.serie.charAt(0) != "B"){
            this.contingencia = true
        }else{
            this.contingencia = false
        }

        this.$swal({
                title: 'Emisión ',
                text: 'Está por emitir el documento' + ' ' + value.serie + '-' + value.numero,
                icon: 'success',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.emitiendoboletas(value)
                }else{
                    this.action.reset = true,
                    this.itemsCargados = [],
                    this.separarArray = [],
                    this.senddoc = {}   
                }
            }) 
        },
        emitiendoboletas(value){
            if(value.adicional != null){
                this.senddoc.adicional = value.adicional;
            }
            this.senddoc.masivo = value.identificador
            this.senddoc.token = this.$store.getters.userToken;  
            this.senddoc.created_at = value.created_at;
            this.senddoc.emitido = value.emitido;
            this.senddoc.contingencia = this.contingencia
            this.senddoc.fechaEmision = value.fechaEmision;
            this.senddoc.idEmisor = value.idEmisor;
            this.senddoc.idFactura = value.idFactura;
            this.senddoc.idReceptor = value.idReceptor;
            this.senddoc.idUsuario = value.idUsuario;
            this.senddoc.identificador = value.identificador;      
            this.senddoc.importeTotal = parseFloat(value.importeTotal);
            this.senddoc.items = this.itemsCargados;
            this.senddoc.montoTotalImpuestos = parseFloat(value.montoTotalImpuestos);
            if(value.receptor.tipo == 0){
                this.senddoc.receptor.nro = '-',
                this.senddoc.receptor.tipo = value.receptor.tipo;
                this.senddoc.receptor.razonSocial = value.receptor.razonSocial;
                this.senddoc.receptor.direccion = value.receptor.direccion;

                this.senddoc.receiver.idReceptor = '-',
                this.senddoc.receiver.tipo = value.receptor.tipo;
                this.senddoc.receiver.razonSocial = value.receptor.razonSocial;
                this.senddoc.receiver.direccionReferencia = value.receptor.direccion;

            }else{
                this.senddoc.receptor = value.receptor;
            }
            this.senddoc.serie = value.serie;
            if(value.numero == null){

            }else{
                this.senddoc.numero = value.numero;
            }
            this.senddoc.sumatoriaIgv = parseFloat(value.sumatoriaIgv);
            this.senddoc.tipoMoneda = value.tipoMoneda;
            this.senddoc.tipoOperacion = value.tipoOperacion;
            this.senddoc.totalPrecioVenta = parseFloat(value.totalPrecioVenta);;
            this.senddoc.totalValorVenta = parseFloat(value.totalValorVenta);
            this.senddoc.totalVentaGravada = parseFloat(value.totalVentaGravada);
            if(value.totalVentaInafecta == null || 
                value.totalVentaExonerada == null || 
                value.totalVentaGratuita == null){
                this.senddoc.totalVentaGratuita = 0.00
                this.senddoc.totalVentaExonerada = 0.00
                this.senddoc.totalVentaInafecta = 0.00
            }else{
                this.senddoc.totalVentaInafecta = parseFloat(value.totalVentaInafecta);
                this.senddoc.totalVentaExonerada = parseFloat(value.totalVentaExonerada);
                this.senddoc.totalVentaGratuita = parseFloat(value.totalVentaGratuita);
            }
            this.senddoc.updated_at = value.updated_at;
            axios
            .post(process.env.VUE_APP_API_URL + "boletas/emitir",this.senddoc)
            .then(response=>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.action.reset = true,
                this.itemsCargados = [],
                this.separarArray = [],
                this.senddoc = {
                    receptor:{
                    tipo:'',
                    nro:'',
                    razonSocial:'',
                    direccion:''
                    } 
                },
                this.listamasiva()
            ))
            .catch(error=>(
                // this.$snotify.error(error.response.data.msg, "Error"),
                this.action.reset = true,
                    this.itemsCargados = [],
                    this.separarArray = [],
                    this.senddoc = {
                        receptor:{
                            tipo:'',
                            nro:'',
                            razonSocial:'',
                            direccion:''
                        } 
                    },
                this.recivecatch(error.response.data)   
            ))
        },
        recivecatch(value){
            this.modalmasivaboleta = true;
            this.error1 = value.msg
            this.error2 = value.response.message
            this.error3 = value.response.description
        },
        cerrarmodal(){
            this.modalmasivaboleta = false
        },
        masivaBoletas(){
            if(this.listaDocumentos.length > 0){
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/emitir",{
                token:this.$store.getters.userToken,
                tipoComprobante:"03"
            })
            .then(response=>(
                this.$snotify.success(response.data.msg, "Éxito")
            ))
            .catch(error=>(
                this.$snotify.error(error.response.data.msg, "Error")
            ))
            }else{
                 this.$snotify.warning("Ingrese algún Documento", "Atención")
            }
        },
        borrarDocumentosBol(){
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/boletas/eliminarmasivo",{
                token:this.$store.getters.userToken 
            })
            .then(response=>(
                this.$snotify.success(response.data.msg, "Éxito"),
                this.listamasiva()
            ))
            .catch(error=>(
                this.$snotify.warning("Comuniquese con Sitemas por favor", "!Ups Error"),
                console.log(error.response.data.msg)
            ))
        },
        subirAdicionales(){
            if(this.adicionales != null){
            let dataItems = new FormData();
            dataItems.append("token",this.$store.getters.userToken);
            dataItems.append("adicionales",this.adicionales);
            axios
            .post(process.env.VUE_APP_API_URL + "facturacionmasiva/factura/adicional", 
                dataItems,
                {
                    responseType: "blob",
                    headers: {
                    "Content-Type": "multipart/form-data"
                    }
                }
            )
            .then(response=>(
                this.$snotify.success("Items importados exitosamente!", "Exito"),
                this.adicionales = null
                //this.changeTab(1)
            ))
            .catch(error=>(
                this.$swal({
                    title: 'Error al cargar documento',
                    text: 'Revisar que el documento de Excel este rellenado correctamente',
                    icon: 'error',
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                    this.adicionales = null
                    }
                })    
            )) 
            }else{
               console.log('sin adicionales')  
            } 
        },
        abrirModal(item) {
            this.dataSeleccionada = item; // Guardar la fila seleccionada
            this.mostrarModal = true; // Mostrar el modal
        }
    },
}
</script>
<style lang="scss" scoped>
.wrapper{
//   width:210%;
//   height:100%;
  display:flex;
  align-items:center;
  justify-content:center;

    .file-upload{
        height:60px;
        width:60px;
        border-radius: 100px;
        position:relative;
        
        display:flex;
        justify-content:center;
        align-items: center;  

        border:4px solid #E4E4E6;
        overflow:hidden;
        background-image: linear-gradient(to bottom, #2590EB 50%, #E4E4E6 50%);
        background-size: 100% 200%;
        transition: all 1s;
        color: #FFFFFF;
        font-size:20px;
        
        input[type='file']{
        height:220px;
        width:200px;
        position:absolute;
        top:0;
        left:0;
        opacity:0;
        cursor:pointer;
        }
        &:hover{
        background-position: 0 -100%;
        color:#2590EB;
        }
    }
}
.guardar{
    width:40%;
}

</style>